import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from "element-ui";
import store from '../store'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    base:'/crcc/',
    mode:'history',
    routes: [
    {
      path: '/#',
      name: 'homes',
        component:resolve=>(require(["@/pages/home/index.vue"],resolve)),
        meta: {
            title:'',//导航名称
            menuShow: true,
            //定义metaInfo
            metaInfo:{
                title: '',
                meta:[
                    {
                        name:'keywords',
                        content:''
                    },{
                        name:"description",
                        content:'描述'
                    }
                ]
            },
            requireAuth: false
        }
    },
        {
            path: '/',
            name: 'home',
            component:resolve=>(require(["@/pages/home/indexs.vue"],resolve)),
            meta: {
                title:'首页',//导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo:{
                    title: '首页',
                    meta:[
                        {
                            name:'keywords',
                            content:'首页'
                        },{
                            name:"description",
                            content:'描述'
                        }
                    ]
                },
                requireAuth: false
            }
        },
        {
            path: '/agenda',
            name: 'agenda',
            component:resolve=>(require(["@/pages/home/agenda1.vue"],resolve)),
            meta: {
                title:'生物制药洁净技术论坛',//导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo:{
                    title: '首页',
                    meta:[
                        {
                            name:'keywords',
                            content:'首页'
                        },{
                            name:"description",
                            content:'描述'
                        }
                    ]
                },
                requireAuth: false
            }
        },
        {
            path: '/agendas',
            name: 'agendas',
            component:resolve=>(require(["@/pages/home/agendas.vue"],resolve)),
            meta: {
                title:'首届洁净云论坛',//导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo:{
                    title: '首页',
                    meta:[
                        {
                            name:'keywords',
                            content:'首页'
                        },{
                            name:"description",
                            content:'描述'
                        }
                    ]
                },
                requireAuth: false
            }
        },
        {
            path: '/schedule',
            name: 'schedule',
            component:resolve=>(require(["@/pages/home/schedule.vue"],resolve)),
            meta: {
                title:'议程',//导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo:{
                    title: '议程',
                    meta:[
                        {
                            name:'keywords',
                            content:'议程'
                        },{
                            name:"description",
                            content:'议程'
                        }
                    ]
                },
                requireAuth: false
            }
        },
    {
        path: '/images',
        name: 'images',
        component:resolve=>(require(["@/pages/home/images.vue"],resolve)),
        meta: {
            title:'Chip China晶芯研讨会',//导航名称
            menuShow: true,
            //定义metaInfo
            metaInfo:{
                title: 'Chip China晶芯研讨会',
                meta:[
                    {
                        name:'keywords',
                        content:'半导体芯科技'
                    },{
                        name:"description",
                        content:'描述'
                    }
                ]
            },
            requireAuth: false
        }
    },
    {
        path: '/into/:mid',
        name: 'into',
          component:resolve=>(require(["@/pages/user/into.vue"],resolve)),
          meta: {
              title:'报名',//导航名称
              menuShow: true,
              //定义metaInfo
              metaInfo:{
                  title: '报名',
                  meta:[
                      {
                          name:'keywords',
                          content:'报名'
                      },{
                          name:"description",
                          content:'报名'
                      }
                  ]
              },
              requireAuth: false
          }
      },
      {
        path: '/previous',
        name: 'previous',
          component:resolve=>(require(["@/pages/home/previous.vue"],resolve)),
          meta: {
              title:'历届合作',//导航名称
              menuShow: true,
              //定义metaInfo
              metaInfo:{
                  title: '历届合作',
                  meta:[
                      {
                          name:'keywords',
                          content:'历届合作'
                      },{
                          name:"description",
                          content:'历届合作'
                      }
                  ]
              },
              requireAuth: false
          }
      },
      {
        path: '/about',
        name: 'about',
          component:resolve=>(require(["@/pages/about/index.vue"],resolve)),
          meta: {
              title:'关于我们',//导航名称
              menuShow: true,
              //定义metaInfo
              metaInfo:{
                  title: '关于我们',
                  meta:[
                      {
                          name:'keywords',
                          content:'关于我们'
                      },{
                          name:"description",
                          content:'关于我们'
                      }
                  ]
              },
              requireAuth: false
          }
      },
      {
        path: '/meeting',
        name: 'meeting',
          component:resolve=>(require(["@/pages/meeting/index.vue"],resolve)),
          meta: {
              title:'在线会议',//导航名称
              menuShow: true,
              //定义metaInfo
              metaInfo:{
                  title: '在线会议',
                  meta:[
                      {
                          name:'keywords',
                          content:'在线会议'
                      },{
                          name:"description",
                          content:'在线会议'
                      }
                  ]
              },
              requireAuth: false
          }
      },
      {
        path: '/detail/:id',
        name: 'detail',
          component:resolve=>(require(["@/pages/meeting/detail.vue"],resolve)),
          meta: {
              title:'在线会议',//导航名称
              menuShow: true,
              //定义metaInfo
              metaInfo:{
                  title: '在线会议',
                  meta:[
                      {
                          name:'keywords',
                          content:'在线会议'
                      },{
                          name:"description",
                          content:'在线会议'
                      }
                  ]
              },
              requireAuth: false
          }
      },
      {
        path: '/publish',
        name: 'publish',
          component:resolve=>(require(["@/pages/home/publish.vue"],resolve)),
          meta: {
              title:'发布供需',//导航名称
              menuShow: true,
              //定义metaInfo
              metaInfo:{
                  title: '发布供需',
                  meta:[
                      {
                          name:'keywords',
                          content:'发布供需'
                      },{
                          name:"description",
                          content:'发布供需'
                      }
                  ]
              },
              requireAuth: false
          }
      },
        {
            path: '/sign/:mid',
            name: 'sign',
            component:resolve=>(require(["@/pages/home/sign.vue"],resolve)),
            meta: {
                title:'在线签到',//导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo:{
                    title: 'Chip China晶芯研讨会',
                    meta:[
                        {
                            name:'keywords',
                            content:'工业AI'
                        },{
                            name:"description",
                            content:'描述'
                        }
                    ]
                },
                requireAuth: false
            }
        },
        {
            path: '/questionnaire/:mid',
            name: 'questionnaire',
            component:resolve=>(require(["@/pages/home/questionnaire.vue"],resolve)),
            meta: {
                title:'在线调研',//导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo:{
                    title: 'Chip China晶芯研讨会',
                    meta:[
                        {
                            name:'keywords',
                            content:'在线调研'
                        },{
                            name:"description",
                            content:'描述'
                        }
                    ]
                },
                requireAuth: false
            }
        },
      {
        path: '/mobile',
        name: 'mhome',
          component:resolve=>(require(["@/pages/mobile/home.vue"],resolve)),
          meta: {
              title:'Chip China晶芯研讨会',//导航名称
              menuShow: true,
              //定义metaInfo
              metaInfo:{
                  title: 'Chip China晶芯研讨会',
                  meta:[
                      {
                          name:'keywords',
                          content:'工业AI'
                      },{
                          name:"description",
                          content:'描述'
                      }
                  ]
              },
              requireAuth: false
          }
      },
  ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
})
export default router
router.beforeEach((to, from, next) => {
    if (!store.getters.lang) {
        let lang = navigator.language.toLowerCase()
        if (lang === 'zh' || lang === 'zh-cn') {
            store.commit('setLang','zh-CN')
        } else {
            store.commit('setLang','en-US')
        }
    }
    if (to.matched.length === 0) {  // 如果未匹配到路由
        from.name ? next({ name: from.name }) : next('/')
    } else {
        //store.commit('showLoading',true);
        next()  // 如果匹配到正确跳转
    }
    if (to.matched.some(record => record.meta.requireAuth)) {
        next()
        var token = store.getters.access_token
        if(!token || token==''){
            ElementUI.Message({
                message: '请先登录',
                type: 'error',
            });
            next({
                path: '/login',
                query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            });
        }else{
            //store.commit('showLoading',true);
            next()
        }
    }else{
        next()
    }
})
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});



// WEBPACK FOOTER //
// ./src/router/index.js